import React from "react";

const EbtcIcon: React.FC = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 21.5C17.2467 21.5 21.5 17.2467 21.5 12C21.5 6.75329 17.2467 2.5 12 2.5C6.75329 2.5 2.5 6.75329 2.5 12C2.5 17.2467 6.75329 21.5 12 21.5ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.1535 8.51932C14.4106 8.64014 15.404 9.02368 15.5142 10.1839L15.5161 10.181C15.6005 11.0248 15.2457 11.5321 14.681 11.8197C15.6101 12.0412 16.1912 12.5935 16.0752 13.8333C15.9275 15.3723 14.7874 15.7818 13.1468 15.8776V17.4857H12.1755V15.8901H11.3997V17.4962H10.4284V15.8661H8.46753L8.6593 14.703C8.6593 14.703 9.37845 14.7145 9.36599 14.703C9.41108 14.7059 9.4563 14.6998 9.49905 14.6852C9.54179 14.6705 9.58122 14.6475 9.61507 14.6176C9.64893 14.5877 9.67654 14.5514 9.69632 14.5107C9.7161 14.4701 9.72767 14.426 9.73035 14.3809V9.99789C9.71196 9.86897 9.64415 9.75227 9.54125 9.67245C9.43835 9.59264 9.30845 9.55598 9.17901 9.57024C9.18955 9.55777 8.47232 9.57024 8.47232 9.57024V8.52891H10.4409V6.92857H11.4112V8.49727C11.6711 8.48768 11.9319 8.48768 12.1879 8.48768L12.1879 6.92857H13.1535V8.51932ZM11.5933 11.5898C12.259 11.6016 13.702 11.6272 13.702 10.6154C13.702 9.58032 12.306 9.61681 11.6264 9.63458C11.5505 9.63657 11.4836 9.63832 11.4285 9.63832V11.5877C11.4754 11.5877 11.5309 11.5887 11.5933 11.5898ZM11.6149 14.7146C12.4096 14.7262 14.1502 14.7516 14.1526 13.6439L14.1526 13.6464V13.6416L14.1526 13.6439C14.1502 12.5074 12.4803 12.5477 11.665 12.5673C11.5736 12.5695 11.4929 12.5715 11.4266 12.5715V14.7126C11.4805 14.7126 11.5439 14.7136 11.6149 14.7146Z"
      fill="black"
    />
  </svg>
);

export default EbtcIcon;
